import {
  SET_REVIEW_CATEGORY,
  ReviewCategoryActionTypes,
  ReviewCategoryMap,
  AppThunk,
} from '../types';
import ApiClient from '../../loopback/apiClient';

const setReviewCategory = (payload: ReviewCategoryMap): ReviewCategoryActionTypes => ({
  type: SET_REVIEW_CATEGORY,
  payload,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchReviewCategories = (): AppThunk => async (dispatch): Promise<void> => {
  const reviewCategories = await ApiClient.getReviewCategories();
  const reviewCategoryMap = reviewCategories.reduce((acc, revCat) => {
    acc[revCat.id] = revCat;
    return acc;
  }, {} as ReviewCategoryMap);
  dispatch(setReviewCategory(reviewCategoryMap));
};
